<script setup lang="ts">
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const r$ = orderStore.validation.r$;
</script>

<template>
    <VCheckbox
        v-model="orderStore.currentOrder.tos"
        hide-details="auto"
        :error-messages="r$.$errors.tos"
        @focusout="r$.$fields.tos.$touch"
    >
        <template #label>
            <p class="text-medium-emphasis">
                Ik ga akkoord met
                <nuxt-link to="/voorwaarden" target="_blank"
                    >algemene voorwaarden</nuxt-link
                >
                .*
            </p>
        </template>
    </VCheckbox>
    <VCheckbox
        v-model="orderStore.currentOrder.privacy"
        hide-details="auto"
        :error-messages="r$.$errors.privacy"
        @focusout="r$.$fields.privacy.$touch"
    >
        <template #label>
            <p class="text-medium-emphasis">
                Ik ga akkoord met het
                <nuxt-link to="/privacy" target="_blank"
                    >privacybeleid</nuxt-link
                >
                .*
            </p>
        </template>
    </VCheckbox>
</template>
